$(function () {
  /* スマホのメニューを開く */
  var body = $('body');
  var buttonOpen = $('.button_lines,.cover');
  buttonOpen.on('click', function () {
    if (body.hasClass('is-menuClose')) {
      var st = $(window).scrollTop();
      body.css({
        top: st * -1
      });
      body.removeClass('is-menuClose').addClass('is-menuOpen');
    } else {
      var st = parseInt(body.css('top')) * -1;
      body.removeClass('is-menuOpen').addClass('is-menuClose');
      $(window).scrollTop(st);
    }
  });

  /* メニューの階層内を開く */
  var $buttonMore = $('.button_childOpen');
  $buttonMore.each(function () {
    $(this).on('click', function () {
      $(this).parent().toggleClass('is-childOpen');
      $(this).parent().next('.childMenu').slideToggle(150);
    });
  });

  // 運賃表
  $('.fare').each(function () {
    var $this = $(this);
    $(this).find('td,th').on({
      mouseenter: function () {
        var classList = this.classList;
        $this.find('.' + classList[0]).addClass('on');
        if (classList[1] == 'col-0') {
          $(this).addClass('on');
        } else {
          $this.find('.' + classList[1]).addClass('on');
        }
      },
      mouseleave: function () {
        var classList = this.classList;
        $('.' + classList[0]).removeClass('on');
        $('.' + classList[1]).removeClass('on');
      }
    });
  });
  // 運賃表でマウスホイールでスクロールできるようにする
  // $('.fare_table').mycus_hScroll(60); // カッコ内の数字でスクロール量を調節できます。

  /* ==============================
  路線全体の時刻表
  =============================== */
  // $('.scheduleAll_inner').mycus_hScroll(60); // カッコ内の数字でスクロール量を調節できます。
  // ボタンを押したとき
  $('.destination_switch_list').each(function () {
    var $this = $(this);
    var $schedule = $this.parent().find('.scheduleAll_body');
    $this.find('li').addClass('checked');
    $this.find('li').on('click', function () {
      if ($(this).hasClass('checked')) {
        $(this).removeClass('checked');
        var index = $(this).attr('class');
        $schedule.find('.' + index).css({ display: 'none' });
      } else {
        var index = $(this).attr('class');
        $(this).addClass('checked');
        $schedule.find('.' + index).css({ display: 'table-cell' });
      }
    });
  });

  /* タブリスト */
  $('.tabList').each(function () {
    // 最初の要素以外は非表示
    $(this).find('.tabList_tab:first-child').addClass('active');
    $(this).find('.tabList_tab:not(:first-child)').css({ display: 'none' });
    $(this).find('.tabList_button:first-child').addClass('active');

    // ボタンを押したときの処理
    var $tabListButton = $(this).find('.tabList_button');
    var $tabListTabs = $(this).find('.tabList_tabs');
    $tabListButton.each(function () {
      $(this).on('click', function () {
        if (!$(this).hasClass('active')) {
          var tabId = $(this).data('tab');
          $tabListButton.removeClass('active');
          $tabListTabs.find('.active').removeClass('active').css({ display: 'none' });
          $(this).addClass('active');
          $tabListTabs.find(tabId).addClass('active').fadeIn(150);
        }
      });
    });
  });

  /* QandA */
  $('.qanda_box').each(function () {
    $(this).find('.qanda_question').on('click', function () {
      var $parent = $(this).parent();
      $parent.toggleClass('is-open');
      $parent.find('.qanda_answer').fadeToggle(150);
    });
  });

  /* 時刻表検索の絞り込み */
  // var $form = $('#searchForm_schedule').find('form'); // フォームを取得
  // var $routeSelect = $form.find('#searchForm_item_route'); // 路線のセレクトボックスを取得
  // var $busstopSelect = $form.find('#searchForm_item_busstop'); // バス停のセレクトボックス
  // $routeSelect.change(function () {
  //   // 路線のセレクトボックスが変更された時
  //   var cid = $('option:selected').attr('class'); // 選択されたoptionのclassを取得
  //   var flag = $busstopSelect.find('option:selected').hasClass(cid) || cid == null;
  //   if (!flag) {
  //     $busstopSelect.val('');
  //   }
  //   $busstopSelect.find('option').each(function () {
  //     if ($(this).hasClass(cid) || cid == null) {
  //       $(this).show();
  //     } else {
  //       $(this).hide();
  //     }
  //   });
  // });
});

// 運賃表でマウスホイールでスクロールできるようにするための関数
// $.fn.mycus_hScroll = function (amount) {
//   amount = amount || 120;
//   $(this).bind('DOMMouseScroll mousewheel', function (event) {
//     var oEvent = event.originalEvent;
//     var direction = oEvent.detail ? oEvent.detail * -amount : oEvent.wheelDelta;
//     var position = $(this).scrollLeft();
//     position += direction > 0 ? -amount : amount;
//     $(this).scrollLeft(position);
//     event.preventDefault();
//   });
// };
